import { RefObject } from 'react'

import {
  ACCESS_SECTION_GALLERY_CONNECTIONS,
  LearnSectionGalleryItemId,
} from 'Components/Sections/Learn/Gallery/constants'

function getElementCenterRelativeTo(
  container: HTMLElement,
  element: HTMLElement,
): [number, number] {
  const containerRect = container.getBoundingClientRect()
  const elementRect = element.getBoundingClientRect()

  return [
    elementRect.left - containerRect.left + elementRect.width / 2,
    elementRect.top - containerRect.top + elementRect.height / 2,
  ]
}

function getConnectionLines(
  refMap: Record<LearnSectionGalleryItemId, HTMLElement>,
  container: RefObject<HTMLElement>,
) {
  return ACCESS_SECTION_GALLERY_CONNECTIONS.map(([from, to]) => {
    const fromElement = refMap[from]
    const toElement = refMap[to]

    if (!fromElement || !toElement || !container.current) return null

    const fromCenter = getElementCenterRelativeTo(
      container.current,
      fromElement,
    )
    const toCenter = getElementCenterRelativeTo(container.current, toElement)

    return {
      from: fromCenter,
      to: toCenter,
      midpoint: [
        (fromCenter[0] + toCenter[0]) / 2,
        (fromCenter[1] + toCenter[1]) / 2,
      ],
    }
  }).filter(Boolean) as {
    from: [number, number]
    to: [number, number]
    midpoint: [number, number]
  }[]
}

export { getConnectionLines }
